import React from "react";
import { useState } from "react";
import AccountingPeriodLock from "./AccountingPeriodLock";
import MonthEndClosingChecklist from "./MonthEndClosingChecklist";
import Beatloader from "../../../Common/Loaders/Beatloader";

const MonthEndProcessing = () => {
  const [activeTab, setActiveTab] = useState("accounting_period_lock");
  const [pageLoader, setPageLoader] = useState(false);

  const TabButton = ({ id, label }) => (
    <button
      className={`btn mx-1 px-4 py-2 rounded-pill ${
        activeTab === id
          ? "btn-light shadow-sm border"
          : "btn-outline-light text-muted border"
      }`}
      style={{
        background: activeTab === id ? "#ffffff" : "#f5f5f5",
        borderColor: "#e4e4e4",
      }}
      onClick={() => setActiveTab(id)}
    >
      {label}
    </button>
  );
  return (
    <>
      {pageLoader ? (
        <Beatloader />
      ) : (
        <div className="page-wrapper">
          <div className="content">
            {/* Tabs */}
            <div className="d-flex flex-wrap align-items-center mb-4 gap-2">
              {/* <TabButton
                id="month_end_closing_checklist"
                label="Month End Closing Checklist"
              /> */}
              <TabButton
                id="accounting_period_lock"
                label="Accounting Period Lock"
              />
            </div>

            <div className="p-4">
              {/* rcm_note */}
              {activeTab === "month_end_closing_checklist" && (
                <MonthEndClosingChecklist />
              )}

              {/* credit_note */}
              {activeTab === "accounting_period_lock" && (
                <AccountingPeriodLock />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MonthEndProcessing;
